export type DownloadStringAsDocProps = {
  fileName?: string;
  blobProps?: BlobPropertyBag;
};

export async function downloadStringAsDoc(
  content: string,
  options?: DownloadStringAsDocProps,
) {
  (await import('file-saver')).default.saveAs(
    new Blob([content], {
      type: 'text/plain; charset=utf-8',
      ...options?.blobProps,
    }),
    options?.fileName,
  );
}
